import { render } from "./PaginationTable.vue?vue&type=template&id=d690abfe&scoped=true"
import script from "./PaginationTable.vue?vue&type=script&lang=js"
export * from "./PaginationTable.vue?vue&type=script&lang=js"

import "./PaginationTable.vue?vue&type=style&index=0&id=d690abfe&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d690abfe"]])

export default __exports__